<template>
  <div class="user_header">
    <div class="login_header_left">
      <!-- <img src="../../assets/image/Logo/home_side_bar_sdg.png" alt /> -->
        <img
    
        style="height:40px;margin-right:10px"
        src="../../assets/image/Logo/logo.png"
        alt
      />
       <img
            class="home_logo_img1"
            src="../../assets/image/Logo/logo1.png"
            alt
          />
          <img
            class="home_logo_img4"
            src="../../assets/image/Logo/home_side_bar_sdg.png"
            alt
          />
      <div class="login_header_left_title">{{$t('User.Header.Title')}}</div>
    </div>
    <div class="login_header_right">
      <div class="right_home" @click="toIndex()">{{$t('User.Header.Home')}}</div>
      <div class="login_header_language" style="height:50px">
        <Language></Language>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Language: () =>
      import("@/components/PublicComponents/Nav/Language/Language.vue")
  },
  methods: {
      toIndex(){
          this.$router.push('/')
      }
  },
};
</script>

<style lang="scss" scoped>
// @media screen and (min-width: 1026px) {
.user_header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 999;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 45px;
  padding: 0 40px;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(174, 186, 208, 27%);
  .login_header_left {
    //   width: 40px;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
     .home_logo_img4 {
    width: 40px;
    height: 40px;
  }
  .home_logo_img1 {
    height: 40px;
    margin-right: 10px;
  }
    .login_header_left_title {
      font-size: 20px;
      font-weight: 600;
      margin-left: 20px;
      color: rgba(10, 151, 217, 1);
    }
  }
  .login_header_right {
    display: flex;
    flex-direction: row;
    line-height: 50px;
    justify-content: flex-end;
    // align-items: center;
    // height: 72px;
    .right_home {
        cursor: pointer;
      margin-right: 20px;
      margin-top: 0px;
      font-size: 12px;
      
      &:hover{
          color: #0057aa;
      }
    }
  
  }
}
// }
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .user_header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 999;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 45px;
  padding: 0 40px;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(174, 186, 208, 27%);
  .login_header_left {
    //   width: 40px;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
     .home_logo_img4 {
    width: 40px;
    height: 40px;
  }
  .home_logo_img1 {
    height: 40px;
    margin-right: 10px;
  }
    .login_header_left_title {
      font-size: 20px;
      font-weight: 600;
      margin-left: 20px;
      color: rgba(10, 151, 217, 1);
    }
  }
  .login_header_right {
    display: flex;
    flex-direction: row;
    line-height: 50px;
    justify-content: flex-end;
    // align-items: center;
    // height: 72px;
    .right_home {
        cursor: pointer;
      margin-right: 20px;
      margin-top: 0px;
      font-size: 12px;
      
      &:hover{
          color: #0057aa;
      }
    }
  
  }
}
}
</style>